import { createSelector } from 'reselect'
import { dataConstants } from 'services/redux/data/constants'
import ObjectEmployee from 'utils/objects/employee'

const selectEmployeeConfidants = createSelector(
	[
		(state) => {
			return state.data[dataConstants.EMPLOYEES_CONFIDANTS];
		}
	],
	( employeesConfidant ) => {
		return ObjectEmployee.filterInvisible( employeesConfidant )
	}
)

export default selectEmployeeConfidants;